import React, { useRef, useState } from "react";
import { Link, useRouteMatch, withRouter, useHistory } from "react-router-dom";
import { inject, observer } from "mobx-react";
import moment from "moment";
import Routes from "Configs/routes";
import { generateUrl } from "Services/withDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import smoothScrollTo from "Helpers/Scroll";
import { getDeclination } from "Utils/text";
import { getTagUnikalnye } from "Utils/getTagUnikalnye";
import { useSocialNetworksTexts } from "hooks/mappedLocaleText";
import RatesmobileConnectButton from "Containers/Buttons/RatesmobileConnectButton";
import { UnlimitedSocial } from "designSystem/UnlimetedSocial";
import {
	TarifficationMItem,
	PurpleText,
	TariffInfo,
	ProviderLogo,
	MeasureComponent,
	BenefitsList,
	Comments,
} from "ComponentsUI/TarifficationM";
import Button from "ComponentsUI/Button";
import { MobileConnectButton } from "ComponentsUI/Buttons";
import ElitePopup from "ComponentsUI/ElitePopup";
import { DodyAccordionList } from "ComponentsUI/DodyAccordionList";
import ESimIcon from "ComponentsUI/Icons/ESimIcon";
import configRouters from "Configs/routes";

const isNoEmptyObject = (object) => {
	for (let key in object) {
		if (object[key] === 1) {
			return true;
		}
	}
	return false;
};

const wrapWithLink = (component, withLink, url, name) => {
	return withLink ? (
		<Link to={url} aria-label={`Лого компании ${name}`}>
			{component}
		</Link>
	) : (
		component
	);
};

const ESIM_TAG_TRANSLIT = "esim";
const UNIKALNYE = "unikalnye";

const MobileTariffRowContainer = (props) => {
	const {
		ApplicationModel: {
			text,
			modalModel,
			sendingStore,
			siteConfig: {
				settings: {
					frame_esim_mts: frameEsimMtsSettings = 0,
					mobile_button_more: mobileButtonMore = 0,
				},
			},
		},
		match: {
			path,
			params: { tagCode },
		},
		tariff,
	} = props;

	const history = useHistory();
	const tariffRef = useRef(null);
	const haveEsim =
		tariff?.mobile_new?.tag_mobil?.some(({ translit }) => translit === ESIM_TAG_TRANSLIT) || false;
	let cbo = tariff?.provider?.operator_settings?.tariffs?.value;

	const toBezlInterTagRegionURL = generateUrl(Routes.RatesMobile.route, {
		regionUrl: props.match.params.regionUrl,
		tagCode: "bezlimitnyj-internet",
	});

	const closeModal = () => {
		if (modalModel.isOpenMtsConnect) {
			sendMetriks("CLOSE_ESIM_MTS");
			modalModel.toggleModalMtsConnect();
		}
	};

	const checkTagCode = (tagCodeTariff) => {
		return tagCodeTariff === UNIKALNYE;
	};

	const checkTagCodeEsim = (tagCodeTariff) => {
		return tagCodeTariff === ESIM_TAG_TRANSLIT;
	};

	const onClickHandler = async (globalId, actions) => {
		if (actions) {
			sendMetriks("CLICK_CONNECT_ACTION");
		}
		if (globalId == 1874) {
			sendMetriks("CLICK_CONNECT_TINKOFF_FROM_RATESMOBILE");
		}
		if (globalId == 1876) {
			sendMetriks("CLICK_CONNECT_BEELINE_FROM_RATESMOBILE");
		}
		if (globalId == 1880) {
			sendMetriks("CLICK_CONNECT_MEGAFON_FROM_RATESMOBILE");
		}
		if (globalId == 1879) {
			sendMetriks("CLICK_CONNECT_TELE2_FROM_RATESMOBILE");
		}
		if (globalId == 1878) {
			sendMetriks("CLICK_CONNECT_YOTA_FROM_RATESMOBILE");
		}
		if (globalId == 1873) {
			sendMetriks("CLICK_CONNECT_SBER_FROM_RATESMOBILE");
		}

		if (globalId == 1877 && (haveEsim || checkTagCodeEsim(tagCode))) {
			sendMetriks("CLICK_CONNECT_ESIM_MTS");
		}
		if (checkTagCode(tagCode) && props.isRatesMobileRegion) {
			sendMetriks("CLICK_CONNECT_UNIKALNYE_REGION");
		} else if (checkTagCode(tagCode) && !props.isRatesMobileRegion) {
			sendMetriks("CLICK_CONNECT_UNIKALNYE_OPERATOR");
		}
		if (globalId == 1877) {
			sendMetriks("CLICK_CONNECT_MTC_FROM_RATESMOBILE");
			if (checkTagCode(tagCode)) {
				sendMetriks("CLICK_CONNECT_UNIKALNYE_MTS");
			}
		} else if (globalId == 1877 && !props.isRatesMobileRegion && checkTagCode(tagCode)) {
			sendMetriks("CLICK_CONNECT_UNIKALNYE_MTS");
		}
		sendMetriks("CLICK_CONNECT_OPERATORY");
		if (frameEsimMtsSettings && haveEsim && globalId === 1877 && cbo !== "popup") {
			closeModal();

			let promise1 = import("Layouts/modalLayout");
			let promise2 = import("ComponentsUI/Iframes/MtsConnect");
			Promise.all([promise1, promise2]).then((modules) => {
				let ModalLayout = modules[0].default;
				let MtsConnect = modules[1].default;

				modalModel.toggleModalMtsConnect(
					<ModalLayout closeModal={() => closeModal()}>
						<MtsConnect />
					</ModalLayout>
				);
			});
		}
	};

	const OnClickRandomMobileTariff = () => {
		if (configRouters.RatesInHouse.route === path) {
			sendingStore.sendMetriksAndSaveArray("CLICK_PODROB_UNLIM_DOM");
		} else if (configRouters.AddressStreet.route === path) {
			sendingStore.sendMetriksAndSaveArray("CLICK_PODROB_UNLIM_STREET");
		}

		history.push({
			pathname: toBezlInterTagRegionURL,
		});
	};

	const { isExact: isRatesMobilePage } = useRouteMatch(Routes.RatesMobile.route) || {};

	const benefitItems = [];
	const unlimitedSocialData = tariff?.social_unlim;
	if (tariff.internet && tariff.internet.speed_in) {
		benefitItems.push({
			name: `${text.servicesHomeInternet}: ${tariff.internet.speed_in} ${text.MB_PER_SECOND}`,
			icon: "icon-router",
		});
	}
	if (tariff.tv) {
		let tvText = "";
		if (tariff.tv.channels) {
			tvText += `${tariff.tv.channels} `;
			if (tariff.tv.channels_hd) {
				tvText += `+ `;
			}
		}
		if (tariff.tv.channels_hd) {
			tvText += `${tariff.tv.channels_hd}HD `;
		}
		const channelsCount = (tariff.tv?.channels || 0) + (tariff.tv?.channels_hd || 0);

		tvText += getDeclination(
			channelsCount,
			text.SERVICES_CHANNEL_DECLINATION.ONE,
			text.SERVICES_CHANNEL_DECLINATION.TWO,
			text.SERVICES_CHANNEL_DECLINATION.FIVE
		);

		benefitItems.push({
			name: tvText,
			icon: "icon-tv",
		});
	}

	let dodySetupPrice = tariff?.connection?.price
		? {
				name: text.comparisonCostConnect,
				short_description: `${text.one_payment_tariff_activation}${tariff.connection.price}\u00a0${text.servicesRub}`,
			}
		: null;
	let dodyPrepaid = tariff?.price?.system_calculation_connect
		? {
				name: text.advance_payment,
				short_description: `${text.advance_payment_in_connect}${tariff.price.system_calculation_connect}\u00a0${text.servicesRub}`,
			}
		: null;

	let additionalDescription = tariff.addition_description
		? Object.keys(tariff.addition_description).map((elem) => {
				if (elem === "__typename" || !tariff.addition_description?.[elem]) {
					return null;
				}
				return {
					name: text.addition_description[elem],
					short_description: tariff.addition_description[elem],
				};
			})
		: [];

	let additionalDody = [dodySetupPrice, dodyPrepaid];

	const [dodyTariff, setDodyTariff] = useState(
		tariff.dody
			.filter((x) => x.state !== 0)
			.concat(additionalDody.filter(Boolean), additionalDescription?.filter(Boolean))
			.map((dody, i) => ({
				...dody,
				color: dody.name === "Акция",
				isOpened: dody.isOpened || false,
				key: i,
			}))
	);

	const changeDodyTariff = (dody) => {
		if (!dody) {
			return;
		}

		setDodyTariff(
			dodyTariff.map((additionalDody) =>
				additionalDody.key === dody.key
					? { ...additionalDody, isOpened: !additionalDody.isOpened }
					: additionalDody
			)
		);
	};

	const onClickButtonMore = () => {
		sendMetriks("CLICK_DETAIL_MOB_TARIFF");
		if (tariff.provider.global.id === 1877) {
			sendMetriks("CLICK_DETAIL_MTS");
		}
		let dodyNote = dodyTariff.find((elem) => elem.name == text.notes);
		if (!dodyNote?.isOpened) {
			changeDodyTariff(dodyNote);
		}

		let tariffBlock = tariffRef?.current;
		let sizeTariffRow = tariffBlock.offsetTop - 70;

		// Запускается 2 раза скролл, т.к. браузер не всегда нормально ставит скролл с первого раза.
		smoothScrollTo(0, sizeTariffRow);
		setTimeout(() => smoothScrollTo(0, sizeTariffRow), 1);

		// if (tariffBlock) {
		//     tariffBlock.scrollIntoView({block: "center"})
		// }
	};

	const tariffInfo = (
		<TariffInfo
			noWordBreak={true}
			tariffName={<PurpleText>{tariff.name}</PurpleText>}
			shortDescription={tariff.short_description}
			dodyList={
				<DodyAccordionList
					dody={dodyTariff}
					additionalDescription={additionalDescription}
					additionalDody={additionalDody}
					changeDodyTariff={changeDodyTariff}
					parentDody={true}
				/>
			}
			benefitsList={<BenefitsList items={benefitItems} />}
		/>
	);

	const minutesComments =
		tariff.mobile_new.sms_type === 2
			? [`+ ${tariff.mobile_new.sms} ${text.message}`]
			: tariff.mobile_new.sms_type === 1
				? [<Comments text={text} />]
				: null;

	let minutesComponent;
	switch (tariff.mobile_new.calls_type) {
		case 1:
			minutesComponent = (
				<MeasureComponent
					value={<span className="icon24 icon-infinite" />}
					measure={text.min}
					comments={minutesComments}
				/>
			);
			break;
		default:
			minutesComponent = (
				<MeasureComponent
					value={tariff.mobile_new.calls}
					measure={text.min}
					comments={minutesComments}
				/>
			);
			break;
	}

	const toOperatorURL = generateUrl(Routes.OperatoryTariffs.route, {
		regionUrl: props.match.params.regionUrl,
		operator: tariff.provider.url_name,
	});

	const socialNetworksTexts = useSocialNetworksTexts(text);

	const socialData =
		unlimitedSocialData &&
		Object.entries(unlimitedSocialData)
			.filter(([, value]) => value === 1)
			.map(([key]) => ({
				key,
				tooltipText: socialNetworksTexts[key],
			}));

	const unlimitedSocial = isNoEmptyObject(unlimitedSocialData) ? (
		<UnlimitedSocial header={text.unlim} socialData={socialData} />
	) : null;

	const gbComment = [unlimitedSocial];
	let gbComponent;

	switch (tariff.mobile_new.internet_type) {
		case 1:
			gbComponent = (
				<MeasureComponent
					value={<span className="icon24 icon-infinite" />}
					measure={text.GB}
					comments={gbComment}
				/>
			);
			break;
		default:
			gbComponent = (
				<MeasureComponent
					value={tariff.mobile_new.internet}
					measure={text.GB}
					comments={gbComment}
				/>
			);
			break;
	}

	let priceComments = [];

	let actions =
		tariff?.after?.data?.price?.license_fee_month &&
		tariff?.after?.data?.price?.license_fee_month !== tariff.price.license_fee;
	let actionDody = tariff.dody[4].state === 1;

	if (actions) {
		let textTimeGracePeriod = "";

		if (!tariff.after?.rule?.month_cnt || tariff.after.rule.month_cnt === 0) {
			textTimeGracePeriod = `до\u00a0${moment(tariff.after?.rule?.date_end).format("D MMMM YYYY")}`;
		} else {
			textTimeGracePeriod = `${tariff.after.rule.month_cnt}\u00a0${text.SERVICES_MONTH}`;
		}

		priceComments = [
			`${text.ORDER_FORM_GRACE_PERIOD_TITLE}: ${textTimeGracePeriod}`,
			`${text.ORDER_FORM_FEE_PREF}: ${tariff.price.license_fee}\u00a0${text.SERVICES_RUB}`,
		];
	}

	const priceComponent = (
		<MeasureComponent
			value={tariff.displayPrice}
			measure={text.PRICE_IN_MONTH}
			comments={priceComments}
			mobileBigView={true}
			price={true}
			colorPositiveBodyReview={true}
		/>
	);

	const logoComponent = wrapWithLink(
		<ProviderLogo path={tariff.provider.logo_2} name={tariff.provider.name} />,
		isRatesMobilePage,
		toOperatorURL,
		tariff.provider.name
	);

	let buttons = props.transfer ? (
		<MobileConnectButton
			onClick={OnClickRandomMobileTariff}
			texts={text}
			textInDB={text.tariffsReadMore}
		>
			{text.tariffsReadMore}
		</MobileConnectButton>
	) : (
		<RatesmobileConnectButton
			tariff={tariff}
			actions={actions || actionDody}
			onClickHandler={onClickHandler}
		/>
	);

	let buttonMore = Boolean(mobileButtonMore && !props.transfer) ? (
		<Button onClick={onClickButtonMore} buttonMore={true}>
			{text.tariffsReadMore}
		</Button>
	) : null;

	const eliteComponent = tariff.is_exclusive ? (
		<ElitePopup
			flatV2={true}
			text1={getTagUnikalnye(tariff) ? text.unikalnye_tariff : text.exclusive_tariff}
		/>
	) : null;

	const esimBlock = haveEsim ? <ESimIcon /> : null;

	return (
		<TarifficationMItem
			ref={tariffRef}
			eliteComponent={eliteComponent}
			tariffInfo={tariffInfo}
			minutesComponent={minutesComponent}
			gbComponent={gbComponent}
			unlimitedSocial={unlimitedSocial}
			priceComponent={priceComponent}
			logoComponent={logoComponent}
			buttons={buttons}
			esim={esimBlock}
			esimText={text.ESIM}
			buttonMore={buttonMore}
		/>
	);
};

export default withRouter(inject("ApplicationModel")(observer(MobileTariffRowContainer)));
